import React from 'react';
import './FloatingParticles.css';

function FloatingParticles() {
  const colors = ['#ff6b9d', '#c06bff', '#4e9fff', '#1fa2ff'];
  
  return (
    <div className="particles-container">
      {[...Array(15)].map((_, i) => {
        const size = Math.random() * 4 + 2;
        const color = colors[Math.floor(Math.random() * colors.length)];
        const left = Math.random() * 100;
        const top = Math.random() * 100;
        const duration = Math.random() * 10 + 10;
        const delay = Math.random() * 5;
        
        return (
          <div
            key={i}
            className="particle"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              background: `linear-gradient(135deg, ${color} 0%, transparent 100%)`,
              left: `${left}%`,
              top: `${top}%`,
              animationDuration: `${duration}s`,
              animationDelay: `${delay}s`
            }}
          />
        );
      })}
    </div>
  );
}

export default FloatingParticles;
